import { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router'
import { Box } from '@mui/material'
import { Skeleton } from '@mui/material'
import { AppRoutes } from './app-routes'
import LoginRedirect from './components/Login/LoginRedirect'

const PublicLayout = lazy(() => import('./Layouts/PublicLayout'))
const MainLayout = lazy(() => import('./Layouts/MainLayout'))
const Register = lazy(() => import('./components/Register/Register'))
const Forgot = lazy(() => import('./components/Login/Forgot'))
const Login = lazy(() => import('./components/Login/Login'))
const VerifyLogin = lazy(() => import('./components/Login/VerifyLogin'))
const Personvaern = lazy(() => import('./components/Navigation/Personvaern'))
const PageNotFound = lazy(() => import('./components/Navigation/PageNotFound/PageNotFound'))

export const MainRouter = () => {
  return (
    <Suspense
      fallback={
        <Box pt={0.5}>
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      }
    >
      <Switch>
        <Route exact path="/personvaern" component={Personvaern} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/login/verify/:token/" component={VerifyLogin} />
        <Route exact path="/register/:token/" component={Register} />
        <Route exact path="/forgot" component={Forgot} />
        <Route exact path="/login-redirect" component={LoginRedirect} />
        <Route exact path="/forgot/:token/" component={Forgot} />
        <Route path="/public" component={PublicLayout} />
        <Route exact path={AppRoutes.NOT_FOUND} component={PageNotFound} />

        <Route component={MainLayout} />
      </Switch>
    </Suspense>
  )
}
